import { render, staticRenderFns } from "./UsefulInformation.vue?vue&type=template&id=4ea98ac8&scoped=true&"
import script from "./UsefulInformation.vue?vue&type=script&lang=js&"
export * from "./UsefulInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea98ac8",
  null
  
)

export default component.exports